const membersData = [
  {
    position: "이사장",
    name: "윤대순",
    affiliation: "관광경영학박사 & 교육학박사",
    contact: "010-1234-5678",
    image: "/images/member/member1.jpeg",
  },
  {
    position: "원장",
    name: "최용훈",
    affiliation: "(현)K&M관광개발 대표 이사\n경기대학교 관광학 박사",
    contact: "010-3333-4444",
    image: "/images/member/member4.jpeg",
  },
  {
    position: "부원장",
    name: "현승범",
    affiliation: "(현)동남항공 이사\n경기대학교 관광학 박사",
    contact: "010-3333-4444",
    image: "/images/member/member2.jpeg",
  },
  {
    position: "이사",
    name: "이진영",
    affiliation: "(현)하나투어비즈니스 상무\n경기대학교 관광 경영학과 석사",
    contact: "010-8765-4321",
    image: "/images/member/member3.png",
  },
  {
    position: "",
    name: "박은숙",
    affiliation: "(현)연성대학교 호텔관광학과 교수\n관광학 박사",
    contact: "010-1111-2222",
    image: "/images/member/member5.jpeg",
  },
  {
    position: "",
    name: "정주영",
    affiliation:
      "(현)서울대학교 차세대융합기술 책임연구원\n한양대학교 관광학박사",
    contact: "010-1111-2222",
    image: "/images/member/member6.png",
  },
];

export default membersData;
